<template>
  <div>
    <p class="cm-mg-p-wzd">
      {{ $t('production.certification_first_step_info') }}
    </p>
    <hr />
    <div class="row">
      <div class="col-md-2">
        <fg-input
          type="text"
          :label="`${$t('common_words.name')}: *`"
          v-model="model.name"
          name="common_words.name"
          v-validate="modelValidations.name"
          :error="getError('common_words.name', true)"
        ></fg-input>
      </div>
      <div class="col-2">
        <div class="form-group has-label">
          <label>{{ $t('common_words.type_of_capture') }}: *</label>
          <br />
          <el-select
            clearable
            filterable
            class="select-default mb-3 shadow-sm required-catch-type"
            v-model="model.capture_type"
            :placeholder="`${$t('common_words.select')}...`"
            v-bind:disabled="change_type"
          >
            <el-option
              class="select-default"
              :label="$t('common_words.per_allotment')"
              value="1"
            >
            </el-option>
            <el-option
              class="select-default"
              :label="$t('common_words.per_farm')"
              value="2"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="col-2">
        <div class="form-group has-label">
          <label>{{ $t('common_words.type_of_qualification') }}: *</label>
          <br />
          <el-select
            clearable
            filterable
            class="select-primary custom-width-select shadow-sm required-certification-type"
            size="large"
            v-model="model.qualification_type"
            :placeholder="`${$t('common_words.select')}...`"
          >
            <el-option
              v-for="option in certificationQualificationTypes"
              class="select-primary"
              :value="option.id"
              :label="option.label"
              :key="option.id"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="col-md-2">
        <fg-input
          type="number"
          :label="`${$t('common_words.record_quant')}: *`"
          min="1"
          v-model.number="model.total_records"
          name="common_words.record_quantity"
          v-validate="modelValidations.total_records"
          :error="getError('common_words.record_quantity', true)"
          :placeholder="`${$t('common_words.records_number')}...`"
        ></fg-input>
      </div>
      <div class="col-md-2">
        <fg-input
          type="text"
          :label="`${$t('common_words.record_name')}: *`"
          v-model="model.record_name"
          name="nombre de los registros"
          :placeholder="`${$t('common_words.records_name')}...`"
        ></fg-input>
      </div>
      <div class="col-md-2">
        <fg-input
          step="0.01"
          min="0"
          max="100"
          type="number"
          :label="`${$t('common_words.general_percentage_by_task')}: *`"
          v-model="model.discount_percentage"
          name="common_words.general_percentage_by_task"
          v-validate="modelValidations.discount_percentage"
          :error="getError('common_words.general_percentage_by_task', true)"
          placeholder="0.01"
        ></fg-input>
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        <div class="form-group has-label">
          <label>{{ $t('common_words.associated_companies') }}: </label>
          <br />
          <el-select
            collapse-tags
            @change="selectAllFromSelect('model.businesses_id', businesses)"
            multiple
            clearable
            filterable
            class="select-primary custom-width-select required-first-step shadow-sm"
            size="large"
            v-model="model.businesses_id"
            :placeholder="`${$t('common_words.select')}...`"
          >
            <el-option
              v-for="option in businesses"
              class="select-primary selected-all"
              :value="option.id"
              :label="option.name"
              :key="option.id"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="col-4">
        <div class="form-group has-label">
          <label>{{ $t('common_words.associated_profiles2') }}: </label>
          <br />
          <el-select
            collapse-tags
            @change="selectAllFromSelect('model.roles_id', availableRoles)"
            multiple
            clearable
            filterable
            class="select-primary custom-width-select shadow-sm"
            size="large"
            v-model="model.roles_id"
            :placeholder="`${$t('common_words.select')}...`"
          >
            <el-option
              v-for="option in availableRoles"
              class="select-primary selected-all"
              :value="option.id"
              :label="option.name"
              :key="option.id"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="col-4">
        <div class="form-group has-label">
          <label>{{ $t('common_words.associated_users2') }}: </label>
          <br />
          <el-select
            collapse-tags
            @change="selectAllFromSelect('model.users_id', availableUsers)"
            multiple
            clearable
            filterable
            class="select-primary custom-width-select shadow-sm"
            size="large"
            v-model="model.users_id"
            :placeholder="`${$t('common_words.select')}...`"
          >
            <el-option
              v-for="option in availableUsers"
              class="select-primary selected-all"
              :value="option.id"
              :label="`${option.name}`"
              :key="option.id"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-6">
        <div class="form-group has-label">
          <label>{{ $t('common_words.description') }}:</label>
          <br />
          <el-input
            maxlength="500"
            show-word-limit
            type="textarea"
            :rows="2"
            placeholder="..."
            v-model="model.description"
            class="shadow-sm"
          ></el-input>
          <br />
        </div>
      </div>
      <div class="col-6">
        <span style="font-size: 16px" class="text-muted">
          {{ $t('common_words.evidence') }}:
        </span>
        <el-upload
          multiple
          ref="uploadCertificationEvidence"
          :action="getAxiosURL() + '/auth/certifications/admin/uploadEvidence'"
          :data="uploadData"
          :headers="headerInfo"
          :limit="1000"
          :on-change="handleChange"
          :on-remove="handleRemove"
          :on-exceed="handleExceed"
          :on-success="handleSuccess"
          :file-list="fileList"
          :auto-upload="false"
          :accept="acceptedFilesString"
        >
          <el-button size="small mt-1" type="primary">{{
            $t('common_words.click_to_load')
          }}</el-button>
          <div slot="tip" class="mt-2 el-upload__tip">
            {{ $t('common_words.file_size_limit_fivemb') }}
          </div>
        </el-upload>
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util.js';
import i18n from 'src/i18n';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import store from '@/store';
import SweetAlert from 'src/class/Alerts';

export default {
  data() {
    return {
      fileList: [],
      acceptedFilesString: '.pdf,.xlsx,.docx,.pptx',
      headerInfo: {
        Authorization: 'Bearer ' + this.$store.state.auth.token,
        locale: this.$i18n.locale,
      },
      uploadData: {
        user: this.$store.state.auth.user.id,
        idCertification: null,
      },
      model: {
        name: null,
        total_records: 1,
        record_name: null,
        discount_percentage: null,
        description: null,
        capture_type: null,
        businesses_id: [],
        roles_id: [],
        users_id: [],
        qualification_type: 'web',
        evidence: null,
        fileList: [],
      },
      modelValidations: {
        name: {
          required: true,
        },
        discount_percentage: {
          min_value: 0,
          max_value: 100,
        },
        total_records: {
          min_value: 1,
        },
      },
      businesses: [],
      roles: [],
      users: [],
      change_type: false,
    };
  },
  mixins: [MixinPermissions, MixinForm, MixinMasters],

  computed: {
    availableRoles() {
      const tmp = [...this.model.roles_id];
      if (this.model.businesses_id.length > 0) {
        this.model.roles_id = [];
        const response = this.roles.filter((rol) => {
          const businessAffiliates = rol.business.filter((bs) =>
            this.model.businesses_id.includes(bs.id)
          );

          return businessAffiliates.length > 0;
        });

        response.forEach((rol) => {
          if (tmp.includes(0)) this.model.roles_id.push(rol.id);
          else if (tmp.includes(rol.id)) this.model.roles_id.push(rol.id);
        });

        return this.concatAll(response);
      } else return this.concatAll([]);
    },

    availableUsers() {
      const tmp = [...this.model.users_id];
      if (this.model.businesses_id.length > 0) {
        this.model.users_id = [];
        const response = this.users.filter((user) => {
          const businessAffiliates = user.business.filter((bs) =>
            this.model.businesses_id.includes(bs.id)
          );
          return businessAffiliates.length > 0;
        });

        response.forEach((user) => {
          if (tmp.includes(0)) this.model.users_id.push(user.id);
          else if (tmp.includes(user.id)) this.model.users_id.push(user.id);
        });

        return this.concatAll(response);
      } else return this.concatAll([]);
    },

    certificationQualificationTypes() {
      return [
        { id: 'web', label: i18n.t('common_words.web') },
        { id: 'mobile', label: i18n.t('common_words.mobile') },
        { id: 'both', label: i18n.t('common_words.both') },
      ];
    },
  },

  watch: {
    '$i18n.locale': 'getSelectAll',
  },

  methods: {
    validate() {
      return this.$validator.validateAll().then((res) => {
        if (res) {
          if (!this.model.capture_type)
            return store.dispatch(
              'utils/validationInputsRequired',
              '-catch-type'
            );
          if (
            !this.model.qualification_type &&
            this.model.qualification_type.length == 0
          )
            return store.dispatch(
              'utils/validationInputsRequired',
              '-certification-type'
            );
          if (this.model.businesses_id.length == 0)
            return store.dispatch(
              'utils/validationInputsRequired',
              '-first-step'
            );

          this.$emit('on-validated', res, this.model);

          const others = [];
          this.model.businesses_id.map((businessId) =>
            this.businesses.map(
              ({ id, name }) => businessId === id && others.push(name)
            )
          );

          const othersRoles = [];
          this.model.roles_id.map((roleId) =>
            this.roles.map(
              ({ id, name }) => roleId === id && othersRoles.push(name)
            )
          );

          const othersUsers = [];
          this.model.users_id.map((userId) =>
            this.users.map(
              ({ id, first_name, last_name, username }) =>
                userId === id &&
                othersUsers.push(`${first_name} ${last_name} (${username})`)
            )
          );

          this.$emit('fillCertificationForm', 'firstStep', {
            business_name: others,
            roles_name: othersRoles,
            users_name: othersUsers,
            type: this.model.capture_type == 1 ? 'Por Lote' : 'Por Finca',
            qualification_type_label: this.certificationQualificationTypes.find(
              (item) => item.id == this.model.qualification_type
            ).label,
          });

          return res;
        }
      });
    },

    handleRemove(file, fileList) {
      if (this.model.evidence) {
        const dataRemove = {
          route: 'certifications/admin/deleteEvidence',
          fileName: file.name,
          idCertification: this.uploadData.idCertification,
        };
        Axios.postMasters(dataRemove)
          .then()
          .catch((error) => {
            this.showMessageErrors(error);
          });
      }
      this.fileList = fileList;
      this.model.fileList = fileList.map((file) => file.name);
    },

    handleExceed(_, fileList) {
      SweetAlert.warning(
        `${i18n.t('sweet_alert.common.the_limit')} ${
          this.$refs.uploadCertificationEvidence.limit
        },
        ${i18n.t('sweet_alert.common.already_selected')} ${
          fileList.length
        } ${i18n.t('sweet_alert.common.files')}`
      );
    },

    handleSuccess(response) {
      if (response.error) {
        SweetAlert.warning(response.error);
      }
    },

    submitUpload() {
      this.$refs.uploadCertificationEvidence.submit();
      this.fileList = [];
    },

    handleChange(file, fileList) {
      const maxSizeInKB = 5000;
      const isSizeValid = file.size / 1024 > maxSizeInKB;
      if (isSizeValid) {
        SweetAlert.warning(i18n.t('sweet_alert.common.maximum_size_per_file'));
        this.$refs.uploadCertificationEvidence.uploadFiles.pop();
      }
      this.fileList = fileList;
      this.model.fileList = fileList.map((file) => file.name);
    },
  },

  created() {
    this.showHideLoading(true);
    if (this.isCreate() || this.isUpdate()) {
      Promise.all([
        Axios.getMasters('businesses/only'),
        Axios.getMasters('roles/indexfield'),
        Axios.getMasters('users/indexfield'),
      ])
        .then((response) => {
          const [response_business, response_roles, response_users] = response;
          this.businesses = this.concatAll(response_business.data.data);
          this.roles = response_roles.data.data;
          this.users = response_users.data.data;

          let editForm = {};
          if (this.isUpdate() && sessionStorage.getItem('editForm')) {
            editForm = JSON.parse(sessionStorage.getItem('editForm'));
            this.model.qualification_type = editForm.qualification_type;
            this.model.name = editForm.name;
            this.model.total_records = editForm.total_records;
            this.model.record_name = editForm.record_name;
            this.model.discount_percentage = editForm.discount_percentage;
            this.model.description = editForm.description;
            this.model.capture_type = editForm.capture_type;
            this.change_type = editForm.change_type;
            this.model.businesses_id = editForm.businesses_ids;
            this.model.roles_id = editForm.roles_id;
            this.model.users_id = editForm.users_id;
            this.uploadData.idCertification = editForm.id;
            this.model.evidence = editForm.evidence;
            if (isset(editForm.evidence)) {
              this.fileList = editForm.fileList.map((value) => ({
                name: value,
              }));
            }
          }

          if (sessionStorage.getItem('editForm') === null) {
            this.model.businesses_id = this.selectElementsAsignFromModel(
              1,
              this.model.businesses_id,
              this.businesses
            );
            this.model.businesses_id === null &&
              this.businesses.length == 1 &&
              this.model.businesses_id.push(this.businesses[0].id);
          }

          this.showHideLoading();
        })
        .catch((error) => this.showMessageErrors(error));
    } else this.showHideLoading();
  },
};
</script>
